import { css } from 'styled-components';

// https://reactcommunity.org/react-transition-group/css-transition

const TransitionStyles = css`
  /* Fade up - Minimal professional animation */
  .fadeup-enter {
    opacity: 0;
    transform: translateY(12px);
    transition: all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .fadeup-enter-active {
    opacity: 1;
    transform: translateY(0px);
    transition: all 350ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Fade down - Professional minimal animation */
  .fadedown-enter {
    opacity: 0;
    transform: translateY(-10px);
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .fadedown-enter-active {
    opacity: 1;
    transform: translateY(0px);
    transition: all 250ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Fade - Minimal professional transition */
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Enhanced slide animations */
  .slidein-enter {
    opacity: 0;
    transform: translateX(-30px) scale(0.96);
    transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .slidein-enter-active {
    opacity: 1;
    transform: translateX(0) scale(1);
    transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Smooth hover effects */
  .smooth-hover {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .smooth-hover:hover {
    transform: translateY(-2px);
  }

  /* Content reveal animation */
  .content-reveal {
    opacity: 0;
    transform: translateY(20px);
    animation: contentReveal 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  @keyframes contentReveal {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Staggered list animations */
  .stagger-item {
    opacity: 0;
    transform: translateY(15px);
    animation: staggerReveal 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  }

  .stagger-item:nth-child(1) { animation-delay: 0.1s; }
  .stagger-item:nth-child(2) { animation-delay: 0.2s; }
  .stagger-item:nth-child(3) { animation-delay: 0.3s; }
  .stagger-item:nth-child(4) { animation-delay: 0.4s; }
  .stagger-item:nth-child(5) { animation-delay: 0.5s; }
  .stagger-item:nth-child(6) { animation-delay: 0.6s; }

  @keyframes staggerReveal {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Button press animation */
  .press-animation {
    transition: all 0.1s ease;
  }

  .press-animation:active {
    transform: scale(0.98);
  }
    transition: all 350ms cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  .slidein-enter-active {
    opacity: 1;
    transform: translateX(0px) scale(1);
    transition: all 350ms cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  /* Staggered fade in - Smoother */
  .staggered-enter {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
    transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  .staggered-enter-active {
    opacity: 1;
    transform: translateY(0px) scale(1);
    transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
  }

  /* Scale and fade - Optimized */
  .scalefade-enter {
    opacity: 0;
    transform: scale(0.9) translateY(10px);
    transition: all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  .scalefade-enter-active {
    opacity: 1;
    transform: scale(1) translateY(0px);
    transition: all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }

  /* Bounce in - Reduced bounce for fluidity */
  .bouncein-enter {
    opacity: 0;
    transform: scale(0.6);
    transition: all 450ms cubic-bezier(0.68, -0.35, 0.265, 1.35);
  }

  .bouncein-enter-active {
    opacity: 1;
    transform: scale(1);
    transition: all 450ms cubic-bezier(0.68, -0.35, 0.265, 1.35);
  }
`;

export default TransitionStyles;
